import { ClipboardList } from "lucide-react";

const EnrollmentTileDesign = {
  id: "enrollment",
  icon: ClipboardList,
  label: "Enrollment",
  background: "linear-gradient(135deg, var(--color-primary-dark), var(--color-primary))",
  color: "#ffffff",
};

export default EnrollmentTileDesign;
